export default {
    state: {
    // searchSelectedDeveloper: null, // 开发商搜索页选中的开发商
    },
    actions: {},
    mutations: {
    // DEVELOPER_SEARCH_SELECTED(state: any, val: Record<string, any>) {
    //   state.searchSelectedDeveloper = val;
    // }
    },
    getters: {}
};
